export default __webpack_public_path__ + "static/media/CFO.3e9d88d2.png";